import React from "react";

function Cartproduct({ cart, handleQuantityChange, handleRemoveFromCart }) {
  return (
    <div
      key={cart._id}
      className="bg-white shadow-sm rounded-lg p-6 mb-6 border border-gray-200 transition duration-300"
    >
      {/* {cart.items.map((item) => {
        const product = item?.productId;
        return (
          <div
            key={item._id}
            className="flex justify-between mb-4 border-b pb-4"
          >
            {product?.image ? (
              <img
                src={`data:${product.image.contentType};base64,${product.image.data}`}
                alt={product?.name || "Product Image"}
                className="w-28 h-28 object-cover rounded-lg"
              />
            ) : (
              <div className="w-24 h-24 bg-gray-200 rounded-lg flex items-center justify-center">
                <span className="text-sm text-gray-500">No Image</span>
              </div>
            )}
            <div className="flex-1 ml-4">
              <div className="flex justify-between items-center">
                <span className="text-xl font-semibold text-gray-800">
                  {product?.name || "Unknown Product"}
                </span>
                <p className="text-gray-600 font-semibold">
                  Total: ₹
                  {product?.price
                    ? (product.price * item.quantity).toFixed(2)
                    : "0.00"}
                </p>
              </div>
              <p className="text-gray-600 flex gap-2">
                <span className="font-bold">Price:</span> ₹{product?.price || "N/A"}
              </p>
              <p className="text-gray-600 flex gap-2 uppercase font-bold">
                {product?.stock} in stock
              </p>
              <p className="text-gray-600 flex gap-2 items-center mt-2">
                <div className="flex items-center border p-1">
                  <button
                    onClick={() =>
                      item.quantity > product?.minquantity  &&
                      handleQuantityChange(
                        cart._id,
                        item._id,
                        item.quantity - 1,
                        product._id
                      )
                    }
                    className="px-3 py-1 text-gray-700 rounded-lg"
                  >
                    -
                  </button>
                  <span className="mx-2">{item.quantity}</span>
                  <button
                    onClick={() =>
                      item.quantity < product?.maxquantity &&
                      item.quantity < product?.stock &&
                      handleQuantityChange(
                        cart._id,
                        item._id,
                        item.quantity + 1,
                        product._id
                      )
                    }
                    className="px-3 py-1 text-gray-700 rounded-lg"
                  >
                    +
                  </button>
                </div>
              </p>
              <div className="flex justify-end items-center mt-2">
                <button
                  onClick={() => handleRemoveFromCart(cart._id, item._id)}
                  className="underline text-red-500 hover:text-red-700 transition duration-300"
                >
                  Remove from cart
                </button>
              </div>
            </div>
          </div>
        );
      })} */}
      {cart?.items?.map((item) => {
  const product = item?.productId;
  if (!product) return null;  // Early return if product is missing

  return (
    <div
      key={item._id}
      className="flex justify-between mb-4 border-b pb-4"
    >
      {product?.image?.data && product?.image?.contentType ? (
        <img
          src={`data:${product.image.contentType};base64,${product.image.data}`}
          alt={product?.name || "Product Image"}
          className="w-28 h-28 object-cover rounded-lg"
        />
      ) : (
        <div className="w-24 h-24 bg-gray-200 rounded-lg flex items-center justify-center">
          <span className="text-sm text-gray-500">No Image</span>
        </div>
      )}
      <div className="flex-1 ml-4">
        <div className="flex justify-between items-center">
          <span className="text-xl font-semibold text-gray-800">
            {product?.name || "Unknown Product"}
          </span>
          <p className="text-gray-600 font-semibold">
            Total: ₹
            {product?.price
              ? (product.price * item.quantity).toFixed(2)
              : "0.00"}
          </p>
        </div>
        <p className="text-gray-600 flex gap-2">
          <span className="font-bold">Price:</span> ₹{product?.price ? product.price : "N/A"}
        </p>
        <p className="text-gray-600 flex gap-2 uppercase font-bold">
          {product?.stock ? product.stock : 0} in stock
        </p>
        <p className="text-gray-600 flex gap-2 items-center mt-2">
          <div className="flex items-center border p-1">
            <button
              onClick={() =>
                item.quantity > (product?.minquantity || 0) &&
                handleQuantityChange(
                  cart._id,
                  item._id,
                  item.quantity - 1,
                  product._id
                )
              }
              className="px-3 py-1 text-gray-700 rounded-lg"
            >
              -
            </button>
            <span className="mx-2">{item.quantity}</span>
            <button
              onClick={() =>
                item.quantity < (product?.maxquantity || 0) &&
                item.quantity < (product?.stock || 0) &&
                handleQuantityChange(
                  cart._id,
                  item._id,
                  item.quantity + 1,
                  product._id
                )
              }
              className="px-3 py-1 text-gray-700 rounded-lg"
            >
              +
            </button>
          </div>
        </p>
        <div className="flex justify-end items-center mt-2">
          <button
            onClick={() => handleRemoveFromCart(cart._id, item._id)}
            className="underline text-red-500 hover:text-red-700 transition duration-300"
          >
            Remove from cart
          </button>
        </div>
      </div>
    </div>
  );
})}

    </div>
  );
}

export default Cartproduct;
